import ThemeService from "../services/ThemeService";
import ResourcesService from "../services/ResourcesService";
import AppUtil from "./AppUtil";

export default class ThemeLoader {

    constructor(themeId) {
        this.themeId = themeId
    }

    static loadThemes() {
        let themeService = new ThemeService()
        themeService.list().then((response) => {
            webase.model.themes = response
        }).catch((message) => {
            console.log('error loading themes')
            console.log(message)
        })
    }

    loadTheme() {
        console.log('load theme')
        console.log(webase.utils.font)
        let resourcesService = new ResourcesService()
        let appUtil = new AppUtil()
        let url = appUtil.getBaseUrl() + '/resources/webase-fonts.json?t=' + Date.now()
        resourcesService.get(url).then( (response) => {
            webase.model.fonts = response

            let service = new ThemeService()
            service.get(this.themeId).then((response) => {
                let theme = response
                console.log(theme)
                webase.model.theme = theme
                webase.utils.font.loadThemeFonts(theme)
                webase.utils.ui.injectCss(`themes/${theme.id}`)
            }).catch((message) => {
                console.log('error loading theme')
                console.log(message)
            })
        })
    }

    // loadFont(fontFamily) {
    //     let availableWeights = webase.utils.ui.availableWeights(webase.model.fonts, fontFamily)
    //     let weights = availableWeights.join(';')
    //     weights = weights.replace('regular', '400')
    //     webase.utils.ui.injectFont(fontFamily, ':wght@' + weights)
    // }

    static previewTheme(theme) {
        let themeService = new ThemeService()
        themeService.createPreview(theme).then((response) => {
            webase.utils.ui.injectTempCss('theme-preview')
        }).catch((message) => {
            console.log('error creating temp theme')
            console.log(message)
        })
    }

}